<template>
  <section class="vh-lg-100 d-flex align-items-center">
    <div class="container">
      <div
        class="row justify-content-center form-bg-image"
        data-background-lg="assets/img/brand/illustrations/signin.svg"
      >
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div
            class="signin-inner my-3 my-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500"
          >
            <div class="text-center text-md-center mb-4 mt-md-0">
              <img
                :src="$root.URL_ROOT + 'uploads/Content/' + site_logo.image"
                style="margin: 10px 0"
                width="150"
              />
              <h1 class="mb-0 h3">Sign in</h1>
            </div>
            <form action="#" class="mt-4">
              <div class="form-group mb-4">
                <label for="email">Your Role</label>
                <div class="input-group">
                  <span class="input-group-text" id="basic-addon1"
                    ><span class="fa fa-cog"></span
                  ></span>
                  <select v-model="role" class="form-control">
                    <option value="admin">Admin</option>
                    <option value="sub_admin">Sub-Admin</option>
                  </select>
                </div>
              </div>
              <!-- Form -->
              <div class="form-group mb-4">
                <label for="email">Your Username</label>
                <div class="input-group">
                  <span class="input-group-text" id="basic-addon1"
                    ><span class="fa fa-envelope"></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Username"
                    id="email"
                    v-model="username"
                    autofocus
                    required
                  />
                </div>
              </div>
              <!-- End of Form -->
              <div class="form-group">
                <!-- Form -->
                <div class="form-group mb-4">
                  <label for="password">Your Password</label>
                  <div class="input-group">
                    <span class="input-group-text" id="basic-addon2"
                      ><span class="fa fa-unlock-alt"></span
                    ></span>
                    <input
                      type="password"
                      placeholder="Password"
                      class="form-control"
                      v-model="password"
                      id="password"
                      required
                    />
                  </div>
                </div>
                <!-- End of Form -->
                <div
                  class="d-flex justify-content-between align-items-center mb-4"
                >
                  <div class="form-check">
                    <input
                      v-model="reminder"
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="defaultCheck5"
                    />
                    <label class="form-check-label" for="defaultCheck5">
                      Remember me
                    </label>
                  </div>
                  <!-- <div><a href="#" class="small text-right">Lost password?</a></div> -->
                </div>
              </div>
              <button @click.prevent="login" class="btn btn-block btn-primary">
                Sign in
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      username: "",
      password: "",
      reminder: true,
      site_logo: [],
      role: "admin",
      // URL_ROOT:'https://5ineprojects.com/Rapidea/backend/api/'
    };
  },
  mounted() {
    this.site_logos();
    localStorage.removeItem("permissions");
  },
  methods: {
    site_logos() {
      const axios = require("axios");
      var self = this;
      axios
        .post(this.$root.URL_ROOT + "api.php", {
          type: "site_logo",
        })
        .then(function (response) {
          console.log(response);
          var data = response.data;
          self.site_logo = data.data;
        });
    },
    login() {
      var ev = this;
      if (ev.role == "admin") {
        axios({
          method: "POST",
          url: ev.$root.URL_ROOT + "api.php",
          data: {
            type: "adminlogin",
            username: ev.username,
            password: ev.password,
          },
        }).then(function (response) {
          if (response.data.status == "success") {
            const adminPermission = [
              {
                section: "ADMINS",
                permission_name: "View Admin",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "ADMINS",
                permission_name: "Create Admin",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "ADMINS",
                permission_name: "Update Admin",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "ADMINS",
                permission_name: "Delete Admin",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "ADMINS",
                permission_name: "Assign Permissions",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "COUPONS",
                permission_name: "View Coupons",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "COUPONS",
                permission_name: "Create Coupons",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "COUPONS",
                permission_name: "Edit Coupons",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "COUPONS",
                permission_name: "Delete Coupons",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "BULK UPLOAD",
                permission_name: "Upload Data",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "DELIVERY CHARGES",
                permission_name: "View Delivery Charge",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "DELIVERY CHARGES",
                permission_name: "Update Delivery Charge",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "ORDER",
                permission_name: "View Orders",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "ORDER",
                permission_name: "Export Orders",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "ORDER",
                permission_name: "Change Status",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "CATEGORY",
                permission_name: "View Categories",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "CATEGORY",
                permission_name: "Create Category",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "CATEGORY",
                permission_name: "Edit Category",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "CATEGORY",
                permission_name: "Active/Inactive Category",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "OPTIONS",
                permission_name: "View Options",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "OPTIONS",
                permission_name: "Create Option",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "OPTIONS",
                permission_name: "Edit Option",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "OPTIONS",
                permission_name: "Active/Inactive Option",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "OPTION VALUES",
                permission_name: "View Option Values",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "OPTION VALUES",
                permission_name: "Create Option Value",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "OPTION VALUES",
                permission_name: "Edit Option Value",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "OPTION VALUES",
                permission_name: "Active/Inactive Option Value",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "OPTION VALUE TYPES",
                permission_name: "View Option Value Types",
                has_permission: true,
                admin_user_id: 1,
              },
              // {
              //     section: 'OPTION VALUE TYPES',
              //     permission_name: 'Create Option Value Type',
              //     has_permission: true,
              //     admin_user_id: 1
              // },
              // {
              //     section: 'OPTION VALUE TYPES',
              //     permission_name: 'Edit Option Value Type',
              //     has_permission: true,
              //     admin_user_id: 1
              // },
              // {
              //     section: 'OPTION VALUE TYPES',
              //     permission_name: 'Active/Inactive Option Value Type',
              //     has_permission: true,
              //     admin_user_id: 1
              // },
              {
                section: "QUANTITY",
                permission_name: "View Quantity Values",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "QUANTITY",
                permission_name: "Save Quantity Values",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "CONTACT REQUEST",
                permission_name: "View Contact Requests",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "CONTACT REQUEST",
                permission_name: "View Messages",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "CONTACT REQUEST",
                permission_name: "Remove Contact Requests",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "SITE USERS",
                permission_name: "View Site Users",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "SITE USERS",
                permission_name: "Edit Site Users",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "SITE USERS",
                permission_name: "Remove Site Users",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "SITE USERS",
                permission_name: "Abandoned Cart",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "SITE USERS",
                permission_name: "Active/Inactive Site Users",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "SITE USERS",
                permission_name: "Export Site Users",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "TESTIMONIALS",
                permission_name: "View Testimonial",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "TESTIMONIALS",
                permission_name: "Create Testimonial",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "TESTIMONIALS",
                permission_name: "Edit Testimonial",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "TESTIMONIALS",
                permission_name: "Remove Testimonial",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "TESTIMONIALS",
                permission_name: "Active/Inactive Testimonial",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "BLOGS",
                permission_name: "View Blogs",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "BLOGS",
                permission_name: "Create Blogs",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "BLOGS",
                permission_name: "Edit Blogs",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "BLOGS",
                permission_name: "Remove Blogs",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "BLOGS",
                permission_name: "Active/Inactive Blogs",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "SITE LOGO",
                permission_name: "View Site Logo",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "SITE LOGO",
                permission_name: "Update Site Logo",
                has_permission: true,
                admin_user_id: 1,
              },
              {
                section: "SITE LOGO",
                permission_name: "Remove Site Logo",
                has_permission: true,
                admin_user_id: 1,
              },
            ];
            localStorage.setItem(
              "admin",
              JSON.stringify(response.data.session)
            );
            localStorage.setItem(
              "permissions",
              JSON.stringify(adminPermission)
            );
            ev.$router.push({ name: "Dashboard" });
            window.location.href = "/";
          }
        });
      } else {
        const data = {
          type: "loginSubAdmins",
          username: ev.username,
          password: ev.password,
        };
        axios({
          method: "POST",
          url: ev.$root.URL_ROOT + "updatedApiForProducts.php",
          data: data,
        }).then(function (response) {
          if (response.data.status == "success") {
            localStorage.setItem(
              "admin",
              JSON.stringify(response.data.session)
            );
            localStorage.setItem(
              "permissions",
              JSON.stringify(response.data.permissions)
            );
            ev.$router.push({ name: "Dashboard" });
            window.location.href = "/";
          }
        });
      }
    },
  },
};
</script>
